import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { settingsDetails } from '../settings-details-config/RS';
import { statements } from '../statements-config/RS';

export const currentAccount: DeepPartial<CurrentAccountConfig> = {
    overdraft: true,
    settingsDetails,
    statements,
    layout: {
        productInfo: {
            showDisposableAndOverdraftAmount: true,
        },
    },
    sepaMandatesRead: {
        enabled: false,
    },
};
